import { render, staticRenderFns } from "./UserProfilePrivacy.vue?vue&type=template&id=489ea62c&scoped=true"
import script from "./UserProfilePrivacy.vue?vue&type=script&lang=js"
export * from "./UserProfilePrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ea62c",
  null
  
)

export default component.exports